import type { VehicleAccessCandidate } from "../../types/vehicle-access.types";
import type { UserReferenceDto } from "@/lib/api";

/** `null` for a user without a login name: the search lists users by it. */
export function toVehicleAccessCandidate(
	dto: UserReferenceDto
): VehicleAccessCandidate | null {
	if (!dto.remoteId || !dto.userName) return null;
	return {
		remoteId: dto.remoteId,
		username: dto.userName,
		displayName: dto.displayName ?? undefined,
	};
}
